<template>
  <div id="homePage">
    <router-view></router-view>

    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      title="新用户首次登录需修改密码"
      :visible.sync="statusDialog"
      width="40%"
      center
    >
      <el-form
        :model="userForm"
        :rules="rules"
        ref="userForm"
        label-width="150px"
      >
        <el-form-item label="新密码" prop="upwd">
          <el-input clearable show-password v-model="userForm.upwd"></el-input>
        </el-form-item>
        <el-form-item label="再次输入新密码" prop="upwdenter">
          <el-input
            clearable
            show-password
            v-model="userForm.upwdenter"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="statusEnter">确 认</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { firstLoginChangePassword } from '../../api/login.js'
export default {
  name: 'HomePage',
  components: {},
  data() {
    // 密码验证
    var checkpwd = (rule, value, callback) => {
      const reg1 = new RegExp(/^(?=.*[a-z])(?=.*\d).+$/)
      const reg2 = new RegExp(/^(?=.*[A-Z])(?=.*\d).+$/)

      var val = value.replace(/\s+/g, '')
      // console.log('value', value)
      // console.log('value.length', value.length)
      if (val == null) {
        callback(new Error('请输入密码'))
      } else if (val.length < 6 || val.length > 16) {
        callback(new Error('请输入6到16位的数字大小字母组合密码'))
      } else if (!reg1.test(val)) {
        callback(new Error('请输入6到16位的数字大小字母组合密码'))
      } else if (!reg2.test(val)) {
        callback(new Error('请输入6到16位的数字大小字母组合密码'))
      } else {
        callback()
      }
    }

    return {
      statusDialog: false,
      userForm: {
        uid: window.sessionStorage.getItem('userId'),
        upwd: null,
        upwdenter: null
      },
      rules: {
        upwd: {
          required: true,
          validator: checkpwd,
          trigger: ['blur', 'change']
        },
        upwdenter: {
          required: true,
          validator: checkpwd,
          trigger: ['blur', 'change']
        }
      }
    }
  },
  mounted() {
    this.pageLoad()
  },
  methods: {
    pageLoad() {
      var userStatus = window.sessionStorage.getItem('userstatus')
      if (userStatus == 6) {
        this.statusDialog = true
      }
    },

    // 确认
    statusEnter() {
      if (
        this.userForm.upwd.replace(/\s+/g, '') !=
        this.userForm.upwdenter.replace(/\s+/g, '')
      ) {
        return this.$message.error('密码输入不一致！请检查！')
      }

      firstLoginChangePassword({
        id: this.userForm.uid,
        NewPassword: this.userForm.upwd
      }).then((res) => {
        if (res.data.status == 'success') {
          this.statusDialog = false
          this.$message.success('修改成功！请使用新密码重新登录！')
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          window.sessionStorage.removeItem('userId')
          window.sessionStorage.removeItem('userstatus')
          this.$router.push('/login')
        } else if (res.data.status == 'error') {
          this.$message.success('修改失败！请联系管理员！')
        } else {
          this.$message.success('未知异常！请联系管理员！')
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
#homePage {
  padding-top: 2px;
  height: 100%;
  width: 100%;
  background-color: #f8f9ff;
}
</style>